<template>
    <div class="read">
        <div class="item" v-for="item in list" :key="item.efficacyTrackId">
            <div class="header">
                <div class="left">医助{{item.assistantName}}</div>
                <div class="right">{{item.createTime}}</div>
            </div>
            <div class="mian">
                <div class="row">
                    <div class="row-left">跟进状态</div>
                    <div class="row-right">{{item.trackStatus | trackStatusFormat(item.trackStatus)}}</div>
                </div>
                <div class="row">
                    <div class="row-left">跟进信息</div>
                    <div class="row-right">{{item.trackContent}}</div>
                </div>
            </div>
            <div class="footer">
                <div class="footer-left">来自客户：{{item.nickName}}</div>
                <div class="footer-right" @click="editRecord(item)">
                    <span>编辑跟进信息</span>
                    <van-icon name="arrow" />
                </div>
            </div>
        </div>
        <pagination :total="total" @pageChange="pageChange" v-if="total > 5"></pagination>
    </div>
</template>
<script>
    import { selectByCondition } from '../../../api/index'
    export default {
        data() {
            return {
                searchData: {
                    pageNo: 1,
                    pageSize: 5,
                    userMemberId: ''
                },
                list: [],
                total: 0
            }
        },
        activated() {
            if(this.searchData.userMemberId){
                this.selectByCondition()
            }
        },
        methods: {

            editRecord(item) {
                sessionStorage.setItem('editRecord', JSON.stringify(item))
                this.$router.push({
                    path: '/editRecord'
                })
            },
            selectByCondition() {
                this.searchData.userMemberId = this.$route.query.userMemberId
                selectByCondition(this.searchData).then(res => {
                    if(res.code == 0){
                        this.list = res.data.list
                        this.total = res.data.total
                    }
                })
            },
            pageChange(pageNo){
                this.searchData.pageNo = pageNo
                this.selectByCondition()
            }
        }
    }
</script>
<style lang="scss" scoped>
    .read {
        .item {
            padding: 0 20px;
            border: 1px solid #E1E8EF;
            border-radius: 8px;
            margin-bottom: 20px;
            .header {
                padding: 20px 0;
                display: flex;
                justify-content: space-between;
                .left {
                    font-weight: bold;
                    font-size: 18px;
                    color: #333;
                }
                .right {
                    color: #666666;
                    font-size: 14px;
                }
            }
            .mian {
                border-bottom: 1px solid #EEEEEE;
                .row {
                    font-size: 14px;
                    display: flex;
                    margin-bottom: 14px;
                    .row-left {
                        width: 90px;
                        color: #999;
                    }
                    .row-right {
                        color: #333;
                        flex: 1;
                    }
                }
            }
            .footer {
                display: flex;
                justify-content: space-between;
                padding: 15px 0;
                font-size: 14px;
                .footer-left {
                    color: #333;
                }
                .footer-right {
                    color: #0082EF;
                    cursor: pointer;
                    .van-icon {
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>